import React, { useMemo } from 'react';
import { Section, Box, Text } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ContentSection = function ContentSection(_ref) {
  var main = _ref.main,
      aside = _ref.aside,
      description = _ref.description,
      paidTemplateDescription = _ref.paidTemplateDescription,
      isEditableTemplate = _ref.isEditableTemplate;
  var templateDescription = useMemo(function () {
    if (!isEditableTemplate) {
      return null;
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [description && /*#__PURE__*/_jsx(Text, {
        $variant: "p1",
        $mb: 40,
        $styles: {
          opacity: 'var(--wcds-legacy-paragraph-opacity)' // to be removed when VIS is the default theme

        },
        children: description
      }), paidTemplateDescription && /*#__PURE__*/_jsx(Text, {
        $variant: "p1",
        $mb: 40,
        $styles: {
          opacity: 'var(--wcds-legacy-paragraph-opacity)' // to be removed when VIS is the default theme

        },
        children: paidTemplateDescription
      })]
    });
  }, [isEditableTemplate, description, paidTemplateDescription]);
  return /*#__PURE__*/_jsxs(Section, {
    $styles: {
      display: ['block', 'flex'],
      alignItems: [undefined, 'stretch']
    },
    $withLastChildPadding: false,
    children: [/*#__PURE__*/_jsxs(Box, {
      $styles: {
        width: [null, 644, 644, 644]
      },
      $mb: [82, null, null, null],
      $mr: [null, 115, 115, 115],
      children: [templateDescription, main]
    }), /*#__PURE__*/_jsx(Box, {
      $styles: {
        width: [null, 360, 360, 360]
      },
      children: aside
    })]
  });
};

export default ContentSection;